import { Announcement } from '@/api/announcements/announcements.types';
import Image from 'next/image';
import Link from 'next/link';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import { API_STATIC_FILES } from '@/utils/constants';
import { device } from '@/constants/mediaQuery';
import s from './MainSlide.module.scss';

export const MainSlide = ({ slide }: { slide: Announcement }) => {
  const image = `${API_STATIC_FILES}${slide.banner}`;

  return (
    <div className={s.slide}>
      <div className={s.slide__container}>
        <Image
          className={s.slide__image}
          src={image}
          alt={'Изображение на слайдере'}
          sizes={`${device.mobile} 720px, ${device.laptop} 1256px, 100wv`}
          priority
          fill
        />
        <div className={s.slide__inner}>
          <div className={s.slide__title}>{slide.title}</div>
          <div className={s.slide__subtitle} dangerouslySetInnerHTML={{ __html: slide.short_description || '' }} />
          {slide.link
            ? (
              <Link className={s.slide__link} href={slide.link || ''}>
                <ActionButton isDivElement>
                  Узнать подробнее
                </ActionButton>
              </Link>
            )
            : <div className={s.slide__empty} />
          }
        </div>
      </div>
    </div>
  );
};